import { Button, message, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import { useStage } from '@/comp/pages/LifecyclePage/Stage/Provider';
import { useStores } from '@/hooks/use-stores';

export const BlockEvents = observer(() => {
  const { lifecycleStore } = useStores();
  const { setIsBlockedReasonModalOpen, unblockSingleBlock, unblockStage } = lifecycleStore;
  const { t } = useTranslation();
  const { blocks, isCurrent } = useStage();

  const isBlockEventsExist = blocks?.length > 0;
  const activeBlocks = blocks.filter(({ endAt }) => !endAt);
  const isActiveBlockReasons = isCurrent && activeBlocks.length > 0;

  const handleUnblock = async (blockId: number) => {
    message.loading({
      content: t('Unblocking...'),
      duration: 15,
      key: 'unblock-reason',
    });

    const isLastActiveBlock = activeBlocks.length === 1;
    const success = isLastActiveBlock ? await unblockStage() : await unblockSingleBlock(blockId);

    if (success) {
      message.success({
        content: t('Unblock Success'),
        key: 'unblock-reason',
      });
    } else {
      message.error({
        content: t('Unblock Failed'),
        key: 'unblock-reason',
      });
    }
  };

  return (
    <div className="block-events-container">
      <div className="block-events-section">
        {isBlockEventsExist && (
          <div className="block-events">
            {blocks?.map(block => (
              <div key={block.id} className="block-event">
                <div className="block-event-date">{dayjs(block.createdAt).format('MMM DD, YYYY [|] HH:mm')}</div>
                <div className="block-event-date block-event-date-separator">-</div>
                {block.endAt ? (
                  <div className="block-event-date">{dayjs(block.endAt).format('MMM DD, YYYY [|] HH:mm')}</div>
                ) : (
                  <div className="unblock-reason" onClick={() => handleUnblock(block.id)}>
                    {t('Unblock')}
                  </div>
                )}
                <Tooltip title={block.customReason || t(block.reason?.name)} placement="right">
                  <div className="block-event-name">{block.customReason || t(block.reason?.name)}</div>
                </Tooltip>
              </div>
            ))}
          </div>
        )}
        {isCurrent && isActiveBlockReasons && (
          <Button type="text" onClick={() => setIsBlockedReasonModalOpen(true)} className="add-block-event-button">
            {`+ ${t('add')}`}
          </Button>
        )}
      </div>
    </div>
  );
});
